import React from 'react';
export const SessionWrapperContext = React.createContext<any>(undefined);
